import Repository from '../Repository';
import { useToast } from 'vue-toastification';

const resource = '/synchronizer';
const toast = useToast();

export default {
	list(params) {
		return Repository.get(`${resource}/list`, { params: params });
	}
}